
<div>
  <ngb-progressbar type="primary" [max]="100" [value]="(100 * value / max) || 0" [animated]="animate"></ngb-progressbar>
</div>
<div class="values">
  <div aria-hidden="true">{{text}}</div>
  <div aria-hidden="true">{{maxText}}</div>
</div>